/* import __COLOCATED_TEMPLATE__ from './google-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();